import { Base } from "@studiometa/js-toolkit";
class FrameAnchor extends Base {
  /**
   * Config.
   */
  static config = {
    name: "FrameAnchor"
  };
  /**
   * Get the URL.
   */
  get href() {
    return this.$el.href;
  }
}
export {
  FrameAnchor
};
//# sourceMappingURL=FrameAnchor.js.map
